import ChatNotesList from './ChatNotesList';
export default ChatNotesList;
